import type { ConfigMetaData } from '@core/services/meta-custom.service';

import { LangEnum } from '@wizbii/utils/models';

type IMetadata = Record<string, ConfigMetaData>;

export const metadata: IMetadata = {
  home: {
    title: $localize`:@@metadata.home.title:WIZBII - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.home.description:Plus de 500 aides financières pour les étudiants et jeunes actifs. Trouvez-les gratuitement en 5 minutes !`,
    image: ``,
  },
  helps: {
    title: $localize`:@@metadata.helps.title:WIZBII - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.helps.description:Plus de 500 aides financières pour les étudiants et jeunes actifs. Trouvez-les gratuitement en 5 minutes !`,
    image: ``,
  },
  summary: {
    title: $localize`:@@metadata.summary.title:WIZBII - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.summary.description:Aide financière étudiante : Retrouvez rapidement les aides auxquelles vous avez droit. Un questionnaire simple et pratique qui regroupe de nombreuses aides nationales et régionales`,
    image: ``,
  },
  dashboard: {
    title: $localize`:@@metadata.dashboard.title:WIZBII - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.dashboard.description:Plus de 500 aides financières pour les étudiants et jeunes actifs. Trouvez-les gratuitement en 5 minutes !`,
    image: ``,
  },
  help_player: {
    title: $localize`:@@metadata.player.title:WIZBII - Découvrez toutes vos aides`,
    description: $localize`:@@metadata.player.description:Plus de 500 aides financières pour les étudiants et jeunes actifs. Trouvez-les gratuitement en 5 minutes !`,
    image: ``,
  },
};

export const ogImageByLang: Partial<Record<LangEnum, string>> = {
  [LangEnum.fr]: 'https://storage.googleapis.com/wizbii-images/money-intl/home/og-image-fr.png',
  [LangEnum.it]: 'https://storage.googleapis.com/wizbii-images/money-intl/home/og-img-it.png',
  [LangEnum.es]: 'https://storage.googleapis.com/wizbii-images/money-intl/home/og-image-es.png',
  [LangEnum.de]: 'https://storage.googleapis.com/wizbii-images/money-intl/home/og-image-de.png',
};
